<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="기간" cols="3">
        <date-input
          :start-date="startDate"
          :end-date="endDate"
          @updateDate="updateDate"
        />
      </field-input>
      <field-input title="조직" cols="2">
        <v-text-field
          v-model="orgNm"
          outlined hide-details dense
          background-color="grey lighten-5" disabled
        />
      </field-input>
      <field-input title="사용자" cols="2">
        <v-text-field
          v-model="memberNm"
          outlined hide-details dense
          background-color="grey lighten-5" disabled
        />
      </field-input>
    </template>
    <template v-slot:button>
      <search-btn @click="search" />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import SearchBtn from "@/common/components/SearchBtn.vue";
import DateMixin from "@/mixin/DateMixin";
import {mapGetters} from "vuex";
import FieldInput from "@/common/components/input/FieldInput.vue";
import DateInput from "@/common/components/input/DateInput.vue";

export default {
  name: "LoanPerformanceMinSearchBar",
  components: {DateInput, FieldInput, SearchBtn, SearchLayout},
  mixins: [DateMixin],
  data() {
    return {
      startDate: "",
      endDate: "",
      orgNm: "",
      memberNm: ""
    }
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData"
    })
  },
  beforeMount() {
    const {fromDate, toDate} = this.getNowMonthAllDate();
    this.startDate = fromDate;
    this.endDate = toDate;
    this.orgNm = this.userData.orgNm + "팀";
    this.memberNm = this.userData.memberNm;
  },
  methods: {
    search() {
      const params = {
        stDt: this.startDate.replaceAll("-", ""),
        edDt: this.endDate.replaceAll("-", ""),
        nm: this.memberNm,
        team: this.orgNm.replace("팀", ""),
      };
      this.$emit("search", params);
    },
    updateDate(value) {
      this.startDate = value[0];
      this.endDate = value[1];
    }
  }
}
</script>